import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from '../utils/utils.service';
import { OnDisplayService } from '../ondisplay/onDisplay.service';

@Injectable({
	providedIn: 'root',
})
export class MyProductionService {
	constructor(
		private http: HttpClient,
		private utils: UtilsService,
		private onDisplaySrv: OnDisplayService,
	) {}

	getThisWeeksLeads(userId: any, weekStart?: string): Observable<any> {
		const formData: any = new FormData();
		formData.append('user_id', userId);
		if (weekStart) {
			formData.append('week_start', weekStart);
		}

		const url: string = `${environment.api}caller/lead/get_this_weeks_leads`;
		return this.http.post(url, formData);
	}
}
